import { PointType } from './pointtype.enum';
import { ILocation, Location } from './location';
import { IDispatchPoint, DispatchPoint } from './dispatchpoint';
import { Direction } from './direction.enum';

export class LineItemModify {
  lineNumber: string;
  direction?: Direction;
  isCancelled?: boolean;

  constructor(lineItemModify: ILineItemModify) {
    this.lineNumber = lineItemModify.lineNumber;
    this.direction = lineItemModify.direction;
    this.isCancelled = lineItemModify.isCancelled;
  }
}

export interface ILineItemModify {
  lineNumber: string;
  direction?: Direction;
  isCancelled?: boolean;
}